import { useEffect, useState } from 'react';

// Județele și localitățile din România (INS SIRUTA + coduri poștale Poșta Română, prin romania-geo-data, licență MIT).
// Fișierul (~500 KB) se încarcă o singură dată, doar când e nevoie.
export interface Geo {
  judete: [string, string][]; // [cod auto, denumire]
  localitati: Record<string, [string, string][]>; // cod județ → [denumire, cod poștal]
}

let promise: Promise<Geo> | null = null;
export function loadGeo(): Promise<Geo> {
  promise ??= fetch('/geo/ro-localitati.json')
    .then((r) => {
      if (!r.ok) throw new Error('Lista localităților nu a putut fi încărcată');
      return r.json() as Promise<{ j: [string, string][]; l: Record<string, [string, string][]> }>;
    })
    .then((d) => ({ judete: d.j, localitati: d.l }))
    .catch((e) => {
      promise = null;
      throw e;
    });
  return promise;
}

export function useGeo(): Geo | null {
  const [geo, setGeo] = useState<Geo | null>(null);
  useEffect(() => {
    let alive = true;
    loadGeo().then((g) => alive && setGeo(g)).catch(() => {});
    return () => { alive = false; };
  }, []);
  return geo;
}

export const plain = (s: string) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();

/** Codul județului după denumire („Brașov”, „Brasov”, „BV”). */
export function judetCode(geo: Geo, name: string | null | undefined): string | undefined {
  if (!name) return undefined;
  const p = plain(name);
  return geo.judete.find(([code, n]) => plain(n) === p || code.toLowerCase() === p)?.[0];
}

/** Caută localitatea în județ (fără diacritice) → denumirea corectă + codul poștal. */
export function findLocalitate(geo: Geo, judet: string | null | undefined, name: string | null | undefined): [string, string] | undefined {
  const code = judetCode(geo, judet);
  if (!code || !name) return undefined;
  const p = plain(name);
  const list = geo.localitati[code] ?? [];
  return list.find(([n]) => plain(n) === p) ?? list.find(([n]) => plain(n).startsWith(p + ' (') || plain(n) === p.replace(/^(mun|or|oras|com|sat)\.?\s*/, ''));
}
